import { ConflictCard } from "../conflict-card";
import type { ConflictBandViewModel } from "./types-conflict-band";

export function ConflictBandView({
  groups,
  className,
  style,
  tratado,
  rotulo,
  testId,
  anchorProps,
  card,
}: ConflictBandViewModel) {
  return (
    <>
      <span
        {...anchorProps}
        className={className}
        style={style}
        aria-label={rotulo}
        data-testid={testId}
      />
      <ConflictCard groups={groups} tratado={tratado} card={card} />
    </>
  );
}
